import React from "react";
import { formatNumberWithCommas } from "../../../../../../../Common/AllDateTimeReleventFormate";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";

export default function GetPrice({ type, price, hiring_type, price2 }) {
  return (
    <>
      {type == 2 ?
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/Prize.svg`}
          alt=""
        /> :
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
          alt=""
        />}
      {  type == 2 ? "Prize" : type == 3 ? "Price": " Budget"}: SAR {formatNumberWithCommas(price)}  {type == 3 &&

        <>
          {
            price2 == undefined ? '' : price2 == 0 ? '' : ` - ${formatNumberWithCommas(price2)}`
          }
        </>}
      {/* { (price2 != undefined || price2 != 0) ? ` - ${formatNumberWithCommas(price2)}` : ''} */}
      {type == 3 && (hiring_type == 1 ? "/hour" : hiring_type == 3 ? "/weekly  " : "/month")}
    </>
  );
}
